import cookieStorage from 'js-cookie';

import CollaborationApp, { getSharedMembers } from 'src/views/collaboration';
import { SwitchEditorModal } from 'src/views/switch-editor/switch-editor';
import { shouldShowSwitchEditorButton } from 'src/views/switch-editor/switch-editor.utils';
import TopBar from 'src/views/top-bar';

import RestrictionsFacade from '../../facade/restrictions/restrictions';

import statusNotification from './status';

const EditorFacade = require('../../facade/editor/editor');

const shareMembersTemplate = require('./collaboration/share-members.hbs');

function createShareModalContainer () {
  const containerId = 'share-modal';
  const element = document.getElementById(containerId);
  if (element) return element;

  const referenceNode = document.querySelector(
    'header .options [data-value="project-name"]'
  );
  const container = document.createElement('div');
  container.id = containerId;

  referenceNode.parentNode.insertBefore(container, referenceNode.nextSibling);

  return container;
}

export async function initShareMembersPanel () {
  const isTemplate = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;
  const isDesygner = INKIVE.Helpers.isDesygnerProject();

  if (isTemplate || isDesygner) {
    return;
  }

  await RestrictionsFacade.initialize();
  const canUseCollaborate = RestrictionsFacade.hasAddOnAndFeature('my_designs', 'collaborate');

  if (!canUseCollaborate) {
    return;
  }

  const container = createShareModalContainer();
  const [sharedMembers, currentUser] = await Promise.all([getSharedMembers(), INKIVE.UserInfoFactory.get()]);
  const currentUserId = currentUser?.id;
  const isOwner = sharedMembers.find((member) => member.id === currentUserId)?.permissionType === 'owner';

  container.innerHTML = shareMembersTemplate({
    members: sharedMembers,
    showIcons: sharedMembers.length > 1,
    label: INKIVE.TranslateHelper.translate(
      'top_submenu.buttons.collaborate'
    ),
    showAddCollaboration: isOwner
  });

  await initShareMembersModal();
}

function initShareMembersModal () {
  document.querySelector('header [data-action="add-collaboration"]').addEventListener('click', () => {
    if (INKIVE.UserInfoFactory.isProPaidUser()) {
      CollaborationApp.mountApp(this);
    } else {
      INKIVE.Helpers.displaySubscriptionModal(
        'tool.versions.helper.description'
      );
    }
  });
}

export function initAnimationPreviewButton () {
  const tmpDiv = document.createElement('div');
  const hasAnimation = INKIVE.AnimationFactory.hasAnimationConfiguration();
  tmpDiv.innerHTML = `<button id="preview-animations" data-action="preview-animations" class="auto-collapse-upper ui-dropdown-button desygner-clear-button ${hasAnimation ? '' : 'hidden'}" data-id="preview-animations">
    <icon>
      <svg fill="#fff">
        <use xlink:href="#video-play-outline"></use>
      </svg>
    </icon>
    <span>
        ${INKIVE.C.SHOW_ANIMATION
    ? INKIVE.TranslateHelper.translate('top_submenu.frame.preview-animations')
    : INKIVE.TranslateHelper.translate('tool.placeholders.preview.title')}
    </span>
  </button>`;

  const referenceNode = document.querySelector('header .options [data-value="project-name"]');
  referenceNode.parentNode.insertBefore(tmpDiv.firstChild, referenceNode.nextSibling);
}

export function redirectToNewEditor () {
  const translate = INKIVE.TranslateHelper.translate;
  cookieStorage.set('editor_preference', 'fluer');
  statusNotification.display(translate('general.saving'), null, true);

  EditorFacade.handle('page', 'save', { confirm_draft: false, force_save: true }).then(() => {
    INKIVE.hasEditorUnsavedChanges = false;
    statusNotification.display(translate('advice.content.nothing_to_save'));
    window.location.reload();
  }, (error) => {
    statusNotification.display(error || translate('common.error'));
  });
}

export function initSwitchEditorButton (isResizing) {
  if (!shouldShowSwitchEditorButton()) {
    return;
  }

  const switchEditorModal = new SwitchEditorModal({
    appId: 'react-action-prompt-app',
    targetNodeSelector: 'body'
  });

  INKIVE.EditorFacade.once('switchEditorModal.show', () => {
    if (!isResizing) {
      switchEditorModal.mountApp({
        onClick: redirectToNewEditor,
        keepOption: () => {
          sessionStorage.setItem('keepCurrentVersion', true);
          switchEditorModal.closeApp();
        },
        isKeepCurrentEditor: sessionStorage.getItem('keepCurrentVersion') || false
      });
    }

    switchEditorModal.createButton(redirectToNewEditor);
  });
}

export async function initTopBar () {
  const companyFactory = require('../../factory/company').instance;
  const data = await companyFactory.getProjectData();

  const isResizing = data.is_resizable && !data.is_resized;

  initAnimationPreviewButton();
  initSwitchEditorButton(isResizing);

  await initShareMembersPanel();
  const attachPoint = document.querySelector('header');
  const buttons = {
    animationModal: document.querySelector('header button#preview-animations')
  };

  INKIVE.TopBar = new TopBar(attachPoint, buttons);
  INKIVE.TopBar.initModals();
}
